import { render } from "./SgOneClickBottomSheet.vue?vue&type=template&id=10dff8e2"
import script from "./SgOneClickBottomSheet.vue?vue&type=script&lang=js"
export * from "./SgOneClickBottomSheet.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__